import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/services/spinner.service';
import { TrackOrderService } from 'src/app/services/track-order.service';
import { TrackParcelService } from 'src/app/services/track-parcel.service';
import { CustomerService } from '../../services/customer.service';
import { DateTimeService } from '../../services/date-time.service';
import { UserService } from '../../services/user.service';

@Component({
	templateUrl: './track-order-details-modal.html',
	selector: 'app-track-order-details-modal',
	styleUrls: ['./track-order-details-modal.scss']
})
export class TrackOrderDetailsModalComponent implements OnInit, OnDestroy {
	public dateTimeFormat: any;
	public id: any;
	public objectUrl: any = '';
	public podAttachments: any[];
	public regularAttachments: any[];
	public selectedCustomer: any;
	public shipment: any;
	public shipmentDetail: any;
	public showMap: boolean;
	public user;
	public userSubscription: any;
	public exceptionColumns: string[] = [];

	constructor(private _userService: UserService,
				private _dateTimeService: DateTimeService,
				private _customerService: CustomerService,
				public dialogRef: MatDialogRef<TrackOrderDetailsModalComponent>,
				private _trackOrderService: TrackOrderService,
				private _spinnerService: SpinnerService,
				private _trackParcelService: TrackParcelService,
				@Inject(MAT_DIALOG_DATA) public data: any) {
	}

	convertToBlob(b64Data, contentType, sliceSize = 512) {
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		return new Blob(byteArrays, { type: contentType });
	}

	ngOnDestroy() {
		if (this.userSubscription) {
			this.userSubscription.unsubscribe();
		}
	}

	ngOnInit() {
		this.userSubscription = this._userService.user$.subscribe((data) => {
			this.user = data;
			if (this.user && this.user.token && this.user.type === 'inet') {
				this.selectedCustomer = this._customerService.getSelectedCustomer();
			}
		});
		this.shipment = this.data.shipment;
		this.shipmentDetail = this.data.shipmentDetail;
		this.regularAttachments = this.shipmentDetail.attachmentDetails?.filter((a) => a.fileCategory !== 'POD_IMAGE');
		this.podAttachments = this.shipmentDetail.attachmentDetails?.filter((a) => a.fileCategory === 'POD_IMAGE');
		this.id = this.data.id;
		this.dateTimeFormat = this._dateTimeService.getDateTime();

		if (this.shipmentDetail.showStatusCodeDescription)
			this.exceptionColumns.push('code');
		if (this.shipmentDetail.showStatusCodeComment)
			this.exceptionColumns.push('comment');
		if (this.shipmentDetail.showStatusCodeTime)
			this.exceptionColumns.push('time');
	}

	openDriverPhoto(d) {
		if (d.photo && d.rawPhoto) {
			const blob = this.convertToBlob(d.rawPhoto, 'image/jpeg');
			// If IE or Edge
			if ((window.navigator as any).msSaveBlob) {
				return (window.navigator as any).msSaveBlob(blob, d.lastName);
			}
			this.objectUrl = (<any>window).URL.createObjectURL(blob);

			this.openObjectUrl(this.objectUrl);
		}
	}

	openObjectUrl(url) {
		const a = document.createElement('a');
		a.style.display = 'none';
		a.setAttribute('href', url);
		a.setAttribute('target', '_blank');
		document.body.appendChild(a);
		a.click();
		a.remove();
		setTimeout(() => {
			(<any>window).URL.revokeObjectURL(url);
		}, 1000);
	}

	getParcel() {
		if (this.shipment) {
			this._spinnerService.startSpinner();
			this._trackOrderService.buildShipment(this.shipment, this.user).then((shipmentDetail) => {
				this.shipmentDetail = shipmentDetail
				this._spinnerService.stopSpinner();
			});
		}
	}

	handelEditParcel(parcel) {
		this._trackParcelService.editParcelModal(parcel, this.shipmentDetail?.custId).then((result) => {
			this.getParcel();
		});
	}

	handelAddParcel(id) {
		this._trackParcelService.addParcelModal(id, this.shipmentDetail?.custId, this.shipmentDetail?.type === 'ROUTESTOP' ? 'stop' : 'order').then((result) => {
			this.getParcel();
		});
	}
}
